//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    x: {
      default: 0,
      type: Number,
    },
    y: {
      default: 0,
      type: Number,
    },
    rotation: {
      default: 0,
      type: Number,
    },
    zoom: {
      default: 1,
      type: Number,
    },
  },
  computed: {
    cameraPosition() {
      return {
        transformOrigin: `center`,
        transform: `translate(${this.x}%, ${this.y}%) rotate(${this.rotation}deg) scale(${this.zoom})`,
      };
    },
  },
};
